<div class="main-container">
    <div class="left-panel">
        <app-sidebar></app-sidebar>
    </div>
    <div class="right-panel">
        <router-outlet></router-outlet>
    </div>
</div>

<!-- BetSlip Mobile Selector -->
<div
    aria-hidden="true"
    class="modal event__modal"
    id="eventsp"
    tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    aria-label="Close"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    type="button"></button>
            </div>
            <div class="left__site__section">
                <div
                    class="tab-content"
                    id="myTabContentmainevent">
                    <div
                        class="tab-pane text-white fade show active"
                        id="mainTabevent"
                        role="tabpanel"
                        tabindex="0"></div>
                </div>
            </div>
        </div>
    </div>
</div>

@if (showBackToTopButton) {
    <button
        class="back-to-top"
        id="back-to-top"
        (click)="scrollToTop()">
        <img
            src="../../../assets/images/svg/up-arrow.svg"
            width="12"
            height="12" />
        <span>
            <span>{{ 'header_menu.back_to_top' | transloco }}</span>
        </span>
    </button>
}
<!-- <app-footer-mobile></app-footer-mobile> -->
